import { render, staticRenderFns } from "./ControlePedidos.vue?vue&type=template&id=b7e48964"
import script from "./ControlePedidos.vue?vue&type=script&lang=js"
export * from "./ControlePedidos.vue?vue&type=script&lang=js"
import style0 from "./ControlePedidos.vue?vue&type=style&index=0&id=b7e48964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports